import DevourClient from 'devour-client';

export const TYPE = 'newsletter/subscription';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			email: '',
		},
		{
			type: TYPE,
		}
	);

	return client;
}
